import { useSearchParams } from "react-router-dom";
import { useProjectRole } from "@/hooks/useProjectRole";
import DatabookBuilderEngine from "./databook-builder/DatabookBuilderEngine";
import DatabookBuilderLegacyEngine from "./databook-builder/DatabookBuilderLegacyEngine";
import { getDatabookBuilderMode } from "./databook-builder/databookBuilderMode";

const DEMO_MODE = import.meta.env?.VITE_DEMO_MODE === "true";

/**
 * Databook Builder page.
 * Typed entry point that mounts the vendored pivot engine.
 * projectId is read from the query string (?projectId=) and used by the
 * upload step. The remaining stages still render from the built-in sample data.
 */
export default function DatabookBuilder() {
  const [searchParams] = useSearchParams();
  const projectId: string | undefined = searchParams.get("projectId") ?? undefined;
  const { canEdit, isLoading: permissionsLoading } = useProjectRole(
    DEMO_MODE ? undefined : projectId,
  );

  if (getDatabookBuilderMode(DEMO_MODE) === "demo") {
    return <DatabookBuilderLegacyEngine />;
  }

  return (
    <DatabookBuilderEngine
      key={projectId ?? "no-project"}
      projectId={projectId}
      canEdit={canEdit}
      permissionsLoading={permissionsLoading}
    />
  );
}
